import { render, staticRenderFns } from "./deviecTransfer.vue?vue&type=template&id=2c4f987e&scoped=true"
import script from "./deviecTransfer.vue?vue&type=script&lang=js"
export * from "./deviecTransfer.vue?vue&type=script&lang=js"
import style0 from "./deviecTransfer.vue?vue&type=style&index=0&id=2c4f987e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f987e",
  null
  
)

export default component.exports